/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formfields_Country1Inputs */

const en_formfields_country1 = /** @type {(inputs: Formfields_Country1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Country`)
};

/**
* | output |
* | --- |
* | "Country" |
*
* @param {Formfields_Country1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const formfields_country1 = /** @type {((inputs?: Formfields_Country1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formfields_Country1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_formfields_country1(inputs)
});
export { formfields_country1 as "formFields_country" }